import { Outlet } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import SynchroForMeSearch from '../components/SynchroForMeSearch';
import { SynchroDataGrid } from '../components/SynchroDataGrid';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '.MuiToolbar-root': {
    marginTop: theme.spacing(3),
  },
}));

const SynchroForMe = () => (
  <Container>
    <SynchroForMeSearch />
    <SynchroDataGrid />
    <Outlet />
  </Container>
);

export default SynchroForMe;
